<template>
  <div class="content">
    
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <!-- <img src="../assets/images/jgg/top.jpg" /> -->
      <div class="center">
      <div class="designinfo">
            <ul>
              <li>
                <!-- <div class="designinfo-title"></div> -->
                一站预订
              </li>
              <li>
                  <i class="iconfont icon-sheji"></i>
                <div class="destitle">设计</div>
              </li>
              <li>
                  <i class="iconfont icon-zhuangxiu"></i>
                <div class="destitle">装修</div>
              </li>
              <li>
                  <i class="iconfont icon-yigui"></i>
                <div class="destitle">定制</div>
              </li>
              <li>
                  <i class="iconfont icon-ruanzhuang"></i>
                <div class="destitle">软装</div>
              </li>
              <li style="border:0">
                  <i class="iconfont icon-chuang"></i>
                <div class="destitle">配套</div>
              </li>
            </ul>
          </div>
       <div class="Design">
          <div class="Design-title">抢免费设计名额</div>
          <div class="forminput">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="ruleForm.clientname" placeholder="请选输入您的称呼"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="tel">
                <el-input v-model="ruleForm.moblephone" placeholder="请选输入您的电话号码"></el-input>
              </el-form-item>
              <el-form-item label="城市" prop="region">
                <VDistpicker
                  :province="ruleForm.clientprovince"
                  :city="ruleForm.clientcity"
                  :area="ruleForm.county"
                  @province="onChangeProvince"
                  @city="onChangeCity"
                  @area="onChangearea"
                ></VDistpicker>
              </el-form-item>
            </el-form>
            <div class="today">
              今日已
              <span style="color:#b31d25;">{{nubs}}</span>人申请免费设计
            </div>
            <div class="btn">
              <el-button @click="application" :disabled="disabled">立即申请</el-button>
              <div class="subcg" v-if="subshow">提交成功,我们会于三个工作日内与您联系</div>
            </div>
          </div>
        </div>
        <div class="Freequote">
          <Freequote></Freequote>
        </div>
      </div>
    </div>
    
    <div class="main">
      <div class="carousel wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <el-carousel height="750px">
          <el-carousel-item v-for="(item,index) in msg3" :key="index">
            <img v-lazy="item.imgurl" oncontextmenu="return false;">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="jggimg wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <div class="Boutique-title">精选产品</div>
        <ul>
          <li>
            <img src="../assets/images/jgg/ap10.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap1.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap2.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap9.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap3.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap4.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap5.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap6.jpg" oncontextmenu="return false;">
          </li>
          <li>
            <img src="../assets/images/jgg/ap7.jpg" oncontextmenu="return false;">
          </li>
        </ul>
      </div>
      <div class="hot2 wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <div class="Boutique-title">服务流程</div>
        <div class="process">
          <ul>
            <li >
              <i class="iconfont icon-zixun"></i>
              <div>装修咨询</div>
            </li>
            <li>
              <i class="iconfont icon-chizi"></i>
              <div>免费量房</div>
            </li>
            <li>
              <i class="iconfont icon-sheji"></i>
              <div>设计协议</div>
            </li>
            <li>
              <i class="iconfont icon-querenfangan"></i>
              <div>方案定稿</div>
            </li>
            <li>
              <i class="iconfont icon-hetong"></i>
              <div>签订合同</div>
            </li>
            <li>
              <i class="iconfont icon-shigong"></i>
              <div>施工阶段</div>
            </li>
            <li>
              <i class="iconfont icon-jiaofangyanshou"></i>
              <div>交房验收</div>
            </li>
            <li style="margin-right: 0px;">
              <i class="iconfont icon-shouhoufuwu-chapingfangyu"></i>
              <div>售后服务</div>
            </li>
          </ul>
        </div>
        <div class="number" style="width:100%;padding-bottom:3rem">
          <img src="../assets/images/jgg/number.png" alt style="width:100%">
        </div>
      </div>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Freequote from "../components/Freequote.vue";
import Rightnav from "../components/Rightnav.vue";
import VDistpicker from "v-distpicker";
import WOW from "wowjs";
export default {
  components: {
  
    BottomFoot,
    VDistpicker,
    Freequote,
    Rightnav
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、50平、80平、100平、120平、150平、毛坯房、旧房改造、免费装修效果图、免费设计效果图桔家云整装，免费为您出装修设计效果图，各种户型、面积均可免费出设计效果图，在线即可免费获取装修设计效果图，数十位大咖设计师为您免费服务！"
        }
      ]
    };
  },
  data() {
    return {
      msg3: [
        { imgurl: require("../assets/images/jgg/1.jpg"), name: "1" },
        { imgurl: require("../assets/images/jgg/2.jpg"), name: "2" },
        { imgurl: require("../assets/images/jgg/3.jpg"), name: "3" }
      ],
      nub: "4",
      showquote: false,
      topnub: 0,
      msg: [
        { imgurl: require("../assets/images/WechatIMG152.jpeg"), name: "1" },
        { imgurl: require("../assets/images/xgt10005602.jpg"), name: "2" },
        { imgurl: require("../assets/images/xgt10005602.jpg"), name: "3" }
      ],
      ruleForm: {
        clientname: "",
        moblephone: "",
        clientprovince: "",
        clientcity: "",
        source: "1",
        county: ""
      },
      rules: {
        clientname: [
          { required: true, message: "请输入您的称呼", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        moblephone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 7, max: 11, message: "请输入正确电话号码", trigger: "blur" }
        ]
      },
      titles: "请选择室",
      titles2: "请选择厅",
      titles3: "请选择卫",
      citys: "请选择城市",
      Province: "请选择省份",
      phone: "",
      radio: "1",
      options: [
        {
          value: "选项1",
          label: "一室"
        },
        {
          value: "选项2",
          label: "二室"
        },
        {
          value: "选项3",
          label: "三室"
        },
        {
          value: "选项4",
          label: "四室"
        },
        {
          value: "选项5",
          label: "五室"
        }
      ],
      options2: [
        {
          value: "选项1",
          label: "一厅"
        },
        {
          value: "选项2",
          label: "二厅"
        },
        {
          value: "选项3",
          label: "三厅"
        }
      ],
      options3: [
        {
          value: "选项1",
          label: "一卫"
        },
        {
          value: "选项2",
          label: "二卫"
        },
        {
          value: "选项3",
          label: "三卫"
        }
      ],
      options4: [
        {
          value: "选项1",
          label: "福建省"
        },
        {
          value: "选项2",
          label: "广东省"
        },
        {
          value: "选项3",
          label: "浙江省"
        }
      ],
      options5: [
        {
          value: "选项1",
          label: "厦门市"
        },
        {
          value: "选项2",
          label: "福州市"
        },
        {
          value: "选项3",
          label: "泉州市"
        }
      ],
      measure: "",
      disabled: false,
      subshow: false,
      nubs: ""
    };
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
  methods: {
    onChangeProvince(data) {
      this.ruleForm.clientprovince = data.value;
    },
    onChangeCity(data) {
      this.ruleForm.clientcity = data.value;
    },
    onChangearea(data) {
      this.ruleForm.county = data.value;
    },
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    application: async function() {
      if (this.ruleForm.clientname == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.moblephone == "") {
        this.$message({
          message: "电话号码不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.clientprovince == "") {
        this.$message({
          message: "省份不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.clientcity == "") {
        this.$message({
          message: "市级不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.county == "") {
        this.$message({
          message: "区/县不能为空",
          type: "warning"
        });
        return false;
      }
      // if (/^([\u4e00-\u9fa5]){2,7}$/.test(this.ruleForm.clientname) == false) {
      //   this.$message({
      //     message: "姓名格式不正确",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if (/^1[3-9]\d{9}$/.test(this.ruleForm.moblephone) == false) {
        this.$message({
          message: "电话号码格式不正确",
          type: "warning"
        });
        return false;
      }
      let ruleForm = this.ruleForm;
      let data = {
        clientcity: ruleForm.clientcity,
        clientname: ruleForm.clientname,
        clientprovince: ruleForm.clientprovince,
        county: ruleForm.county,
        moblephone: ruleForm.moblephone,
        source: "1",
        registertype: "1"
      };
      //console.log("this.ruleForm", data);
      const res = await this.exequy.Immediate(data);
      //console.log("res22", res);
      if (res.data.msg == "success") {
        this.nubs = res.data.num;
        //console.log("resiiiii", this.nubs);
        // this.$message({
        //   message: "提交成功,我们会于三个工作日内与您联系",
        //   type: "success"
        // });
        this.disabled = true;
        this.subshow = true;
      }
    },
    getnub: async function() {
      let data = {
        registertype: "1"
      };
      let resa = await this.exequy.applicants(data);
      this.nubs = resa.data.num;
    }
  },
  created: function() {
    const self = this;
    self.getnub();
  }
};
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.carousel {
  margin-top: 50px;
  height: 750px;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.banane {
  width: 100%;
  height: 750px;
  
  position: relative;
  background-image: url(../assets/images/jgg/top.jpg);
    display: flex;
    align-items: center;
}
.banane img {
  width: 100%;
  height: 100%;
}
.Quota {
  width: 100%;
  overflow: hidden;
  margin-top: 5rem;
}
.Carousels {
  width: 40%;
  float: left;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.Design {
  width: 48%;
  float: left;
}
.forminput {
  width: 80%;
  margin: 0 auto;
}
.forminput >>> .el-form-item__label {
  text-align: center;
  font-size: 17px;
  color: #000;
}
.forminput >>> .el-select {
  width: 100%;
}
.forminput .check-one {
  width: 10px;
  height: 10px;
  background: black;
}
.content >>> .el-form-item {
  padding: 14px;
  margin-bottom: 0px;
}
.Design-title {
  width: 80%;
  color: #000;
  font-size: 30px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 22px;
}
.el-button--default {
  width: 50%;
  background: #b31d25;
  color: #fff;
}
.Freequote {
  width: 50%;
  overflow: hidden;
  float: left;
}
.Freequote-title {
  width: 100%;
  color: #b31d25;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.Science-btn {
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 10px;
}
.Science-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
}
.Science-btn ul li {
  list-style: none;
  width: 120px;
  float: left;
  margin-left: 20px;
}
.btns >>> .el-button--default {
  width: 130px;
  background: #b31d25;
  color: #fff;
}
.today {
  margin-bottom: 21px;
  margin-top: 22px;
  font-size: 20px;
  color: #606266;
}
.hot2 {
  width: 100%;
  margin: 0 auto;
  margin-top: 5rem;
}
.Boutique-title {
  font-size: 36px;
  margin-bottom: 4rem;
  color: #000;
}
.process {
  width: 100%;
  overflow: hidden;
}
.process img {
  width: 100%;
  height: 100%;
}
.process ul li {
  list-style: none;
  height: 10%;
  color: #000;
  float: left;
  margin-right: 110.1px;
}
.process i {
  color: #b31d25;
  font-size: 71px;
}
.process ul li div {
  margin-top: -3px;
  margin-bottom: 8px;
}
.iconfont {
  font-size: 23px;
  color: #fff;
}
.distpicker-address-wrapper >>> select {
  float: left;
  border: 1px solid #dcdfe6;
  width: 30%;
}
.distpicker-address-wrapper >>> select:nth-child(n + 2) {
  margin-left: 10px;
  width: 30%;
}
.el-button--default {
  width: 131px;
  background: #b31d25;
  border: 0px;
  color: #fff;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.designinfo {
  width: 100%;
  height: 3rem;
  background: #b31d25;
  color: #fff;
  line-height: 3rem;
}
.designinfo ul {
  margin-block-start: 0px;
  margin-block-end: 0px;
  padding-inline-start: 0px;
  overflow: hidden;
}
.designinfo ul li {
  width: 10%;
  float: left;
  margin-left: 5%;
  height: 1.5rem;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  color: #fff;
  list-style: none;
  margin-top: 12px;
  border-right: 1px solid #fff;
}
.designinfo ul li:first-child {
  width: 15%;
  margin-left: 8%;
  height: 3rem;
  text-align: center;
  font-size: 23px;
  color: #fff;
  line-height: 2rem;
  border-right: 1px solid #fff;
  margin-top: 0px;
}
.dessize {
  float: left;
  font-size: 14px;
}
.center {
  width: 80%;
  margin: 0 auto;
  height: 500px;
  background: rgba(255, 255, 255, 0.76);
}
.destitle {
  float: left;
  font-size: 18px;
  padding-left: 3px;
  margin-left: 5px;
  /* border-left: 1px solid rgb(141, 141, 141); */
}
.dessize > .iconfont {
  font-size: 14px;
  line-height: 2.5rem;
  margin-left: 10px;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(141, 141, 141);
  border-image: initial;
}
/* .designinfo-title {

} */
.subcg {
  color: #b31d25;
}
.jggimg {
  margin-top: 4rem;
}
.jggimg ul {
  overflow: hidden;
  margin-left: -5%;
}
.jggimg ul li {
  width: 31.3%;
  float: left;
  list-style: none;
  margin-left: 2%;
  margin-top: 20px;
}
.jggimg ul li img {
  width: 100%;
  float: left;
}
span.msg {
  padding: 5px;
  font-size: 12px;
}
span.success {
  background-color: lightGreen;
  color: Green;
}
span.fail {
  background-color: pink;
  color: red;
}
</style>
